import type { ApiMethod, ApiResponse } from '~/utils/apiClient';

import { useAuthStore } from '~/stores/auth/authStore';
import { useCustomerStore } from '~/stores/customer/customerStore';
import { createApiClient } from '~/utils/apiClient';

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig();
  const goTo = useGoTo();

  const api = {
    fetch: <T, U = unknown>(
      method: ApiMethod,
      path: string,
      data?: Record<string, unknown> | null,
      authenticated: boolean = false,
    ): Promise<ApiResponse<T, U>> => {
      const authStore = useAuthStore();
      const customerStore = useCustomerStore();

      return createApiClient<T, U>(method, path, data, authenticated, goTo, runtimeConfig, authStore, customerStore);
    },
  };

  return {
    provide: {
      api,
    },
  };
});
